import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { Stock } from '/@/modules/stock/models/Stock';
import { FinancialAccount } from '/@/modules/financialaccount/models/FinancialAccount';
import { ModelType } from '/@/modules/core/app/constants/ModelType';

export class StockHolding extends BaseEntityModel {
  id?: number;
  financialAccountId?: number;
  stockId?: number;
  numberOfSharesHeld?: number;

  financialAccount?: FinancialAccount;

  stock?: Stock;

  constructor(model: Partial<StockHolding> = {}) {
    super(model);
    super.setRelationships(this, model, this.getModelName());

    this.id = model.id;
    this.financialAccountId = model.financialAccountId;
    this.stockId = model.stockId;
    this.numberOfSharesHeld = model.numberOfSharesHeld;
  }

  getModelName(): ModelType {
    return ModelType.STOCK_HOLDING;
  }

  get stockName(): string | undefined {
    return this.stock?.name;
  }

  get isMissingRequiredInformation(): boolean | undefined {
    return !this.numberOfSharesHeld || !this.stock?.tickerName;
  }

  setStock(stock: Stock): void {
    this.stock = stock;
    this.stockId = stock.id;
  }
}
